import { render, staticRenderFns } from "./foreign_trade.vue?vue&type=template&id=b39cc6a4&scoped=true&"
import script from "./foreign_trade.vue?vue&type=script&lang=js&"
export * from "./foreign_trade.vue?vue&type=script&lang=js&"
import style0 from "./foreign_trade.vue?vue&type=style&index=0&id=b39cc6a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39cc6a4",
  null
  
)

export default component.exports